jQuery(function($){

	// custom code here
	console.log("jQuery ready");

	$(".search-button").on("click", (e) => {
		e.preventDefault();
		$("#searchform").animate({ width: "toggle" });
	});

	// acknowledgement modal
	var isAcknowledged = localStorage.getItem('acknowledged');
	if (!isAcknowledged) {

		var $acknowledgement = $("#acknowledgement").clone();
		$acknowledgement.prependTo("#acknowledgementModal .modal-content");
        
		$("#acknowledgementModal").modal("show").on('hidden.bs.modal', function () {
			localStorage.setItem('acknowledged', 'true');
		});

	}
});
